import React from 'react';
import ActionFormLayout from '../../../../../components/layouts/actions/ActionFormLayouts';
import _ from 'lodash';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { fetchLive, addActionLive, editActionLive, deleteActionLive, endLive } from '../../../../../actions/liveDataActions';
import { withRouter } from 'react-router-dom';
import { LOGO_TEAM_URL } from '../../../../../config.env';
import FreeKickTeamChoice from '../../../../../components/customForm/freekick/FreeKickTeamChoice';
import { List, Toast, Modal } from 'antd-mobile';
import Title from '../../../../../components/Title';
import PickerInput from '../../../../../components/customForm/picker/PickerInput';
import NumberInput from '../../../../../components/customForm/number/NumberInput';
import { Icon } from 'react-onsenui';
import queryString from 'query-string';
import { addAction, edit as editLive } from '../../../../../services/live';
import { addScore, substractScore } from '../../../../../helpers';
import { editAction, removeAction } from '../../../../../services/action';
import { deleteActionLive as removeActionLive } from '../../../../../actions/matchDataActions';

class TirAuButFormPage extends React.Component {
    constructor(props) {
        super(props);
        const qs = queryString.parse(this.props.history.location.search);
        const dataEdited = qs.action_edit ? JSON.parse(qs.action_edit) : null;
        this.editId = dataEdited ? dataEdited['@id'] : null;

        this.state = {
            seq: [],
            shoot: {
                id: this.editId || '',
                team: dataEdited ? parseInt(dataEdited.teamId) : '',
                teamName: dataEdited ? dataEdited.teamName : '',
                player: dataEdited ? dataEdited.data.player : null,
                result: dataEdited ? dataEdited.data.result : '',
                eq: dataEdited ? dataEdited.data.eq : 'home',
                prevEq: dataEdited ? dataEdited.data.eq : 'home',
                prevResult: dataEdited ? dataEdited.data.result : ''
            },
            minute: dataEdited ? dataEdited.minute : (qs.minute || 0),
            score: {home: 0, away: 0},
            formValid: false,
            showBtn: true,
            isOnSubmit: false,
            live: {},
            match: {},
            onProgress: false
        }
        this.id = this.props.match.params.id;
        this.actionId = qs.action_type ? JSON.parse(qs.action_type)['@id'] : '';
        this.editShoot = this.editShoot.bind(this);
        this.removeShoot = this.removeShoot.bind(this);
        this.add = this.add.bind(this);
        this.endSeance = this.endSeance.bind(this);
    }

    componentDidMount() {
        this.props.fetchLive(this.id, this.props.connexionReducer).then(() => {
            this.setState({
                live: this.props.liveDataReducer[`/api/lives/${this.id}`],
                match: this.props.liveDataReducer[`/api/lives/${this.id}`].match
            },() => {
                const tab = _.filter(this.state.live.actions, action => action.data.label === 'tab');
                const seq = [];
                _.forEach(tab, v => {
                    seq.push({
                        id: v['@id'],
                        team: v.teamId,
                        teamName: v.teamName,
                        player: v.data.player,
                        result: v.data.result,
                        eq: v.data.eq,
                        prevEq: v.data.eq,
                        prevResult: v.data.result
                    })
                });
                
                if(!_.isEmpty(seq)) {
                    const last = _.last(tab);
                    const score = !_.isEmpty(last) ? last.data.score : this.state.score;
                    this.setState({seq, score});
                }
            })
        })
    }

    endSeance() {
        const {minute} = this.state;
        const actionType = localStorage.getItem('action_types') ? JSON.parse(localStorage.getItem('action_types')) : {}
        const fin = _.find(actionType, {name: 'Fin de match'});
        return addAction(this.id, {
            type: fin['@id'],
            teamId: null,
            minute,
            teamName: null,
            data: {
                actionName: 'Fin de la séance des tirs au but',
                label: 'fin_de_match'
            }
        }, this.props.connexionReducer).then(response => {
            window.postMessage(JSON.stringify({
                action: 'trackEvent',
                parameters: {
                    label: 'added_live_score',
                    value: 'déclarer une fin tir au but'
                }
            }), '*');
            editLive(this.id, {ended: true}, this.props.connexionReducer).then(r => {
                this.props.endLive(this.id);
            });
            this.props.addActionLive(this.id, response.data);
        })
    }

    add() {
        const {shoot, score, minute, seq} = this.state;
        const data = {
            label: 'tab',
            actionName: `Tir n°${seq.length + 1}`,
            description: shoot.player ? `Tireur ${shoot.teamName} n°${shoot.player}` : '',
            player: shoot.player,
            result: shoot.result,
            eq: shoot.eq,
            score: shoot.result === 'marque' ? addScore(score, shoot.eq) : score
        }

        addAction(this.id, {
            type: this.actionId,
            teamId: shoot.team,
            teamName: shoot.teamName,
            minute,
            data
        }, this.props.connexionReducer).then(response => {
            window.postMessage(JSON.stringify({
                action: 'trackEvent',
                parameters: {
                    label: 'added_live_score',
                    value: 'déclarer un tir au but'
                }
            }), '*');
            this.setState(prevState => {
                const tir = _.assignIn(prevState.shoot, {id: _.last(response.data.actions)['@id']});
                return {
                    shoot: {
                        team: '',
                        teamName: '',
                        player: null,
                        result: '',
                        eq: 'home',
                        prevEq: 'home',
                        prevResult: ''
                    },
                    seq: [...prevState.seq, tir]
                }
            });
            this.props.addActionLive(this.id, response.data);
        })
    }

    addShoot() {
        const {shoot} = this.state;

        if(shoot.team === '' || shoot.teamName === '' || shoot.result === '') {
            return;
        }

        if(this.editId) {
            const {shoot} = this.state;
            this.editShoot(shoot, shoot.prevEq, shoot.prevResult).then(() => this.props.history.push(`/live/${this.id}`))
        }
        else {
            this.add();
        }
    }

    renderSeanceTir() {
        const {match, seq} = this.state;
        return (
            seq.map((shoot, key) => {
                const prevEq = shoot.eq;
                const prevResult = shoot.result
                return (
                    <List key={key} renderHeader={() => <Title text={`détails tir au but ${key + 1}`} />}>
                        <PickerInput 
                            data={[
                                {label: match.homeTeamEqName || match.homeTeam, value: parseInt(match.homeTeamClCod)},
                                {label: match.awayTeamEqName || match.awayTeam, value: parseInt(match.awayTeamClCod)}
                            ]}
                            label='Equipe'
                            extra={'à renseigner'}
                            value={shoot.team}
                            onOk={team => {
                                let editSeq = [...seq]
                                editSeq[key] = {...editSeq[key],
                                    team, 
                                    teamName: team === parseInt(match.homeTeamClCod) ? (match.homeTeamEqName || match.homeTeam) : (match.awayTeamEqName || match.awayTeam),
                                    eq: team === parseInt(match.homeTeamClCod) ? 'home' : 'away'
                                }
                                this.setState({seq: editSeq})
                            }}
                        />
                        <NumberInput 
                            label='Tireur (n° maillot)'
                            placeholder='à renseigner'
                            min={1}
                            max={99}
                            value={shoot.player}
                            defaultValue={shoot.player}
                            onChange={player => {
                                let editSeq = [...seq]
                                editSeq[key] = {...editSeq[key], player}
                                this.setState({seq: editSeq})
                            }}
                            id='ls_maillot_tab'
                            onFocus={() => this.setState({showBtn: false})}
                            onBlur={() => this.setState({showBtn: true})}
                        />
                        <PickerInput 
                            data={[
                                {label: 'Marqué', value: 'marque'},
                                {label: 'Arrêté', value: 'arrete'},
                                {label: 'Manqué', value: 'manque'}
                            ]} 
                            label={'Finalité'} 
                            extra='à renseigner' 
                            value={shoot.result} 
                            onOk={result => {
                                let editSeq = [...seq]
                                editSeq[key] = {...editSeq[key], result}
                                this.setState({seq: editSeq})
                            }} 
                        />
                        <List.Item>
                            <div style={{float: 'right'}} className='common'>
                                <span onClick={() => this.editShoot(this.state.seq[key], prevEq, prevResult).then(() => Toast.success('Succès !'))}>Modifier</span>
                                <span onClick={() => this.removeShoot(this.state.seq[key])} style={{color: '#d0021b', marginLeft: '15px'}}>Supprimer</span>
                            </div>
                        </List.Item>
                    </List>
                )
            })
        )
    }

    editShoot(shoot, prevEq, prevResult) {
        const {score} = this.state;
        let editedScore = score;
        
        if(shoot.eq === prevEq) {
            if(prevResult === shoot.result) {
                editedScore = score;
            }
            else {
                editedScore = shoot.result === 'marque' ? addScore(score, shoot.eq) : (prevResult === 'marque' ? substractScore(score, shoot.eq) : score) 
            }
        }
        else {
            if(prevResult === shoot.result) {
                editedScore = shoot.result === 'marque' ? addScore(substractScore(score,prevEq), shoot.eq) : score
            }
            else {
                editedScore = shoot.result === 'marque' ? addScore(score, shoot.eq) : (prevResult === 'marque' ? substractScore(score, prevEq) :score )
            }
        }
        return editAction(shoot.id, {
            teamId: parseInt(shoot.team),
            teamName: shoot.teamName,
            data: {
                label: 'tab',
                description: shoot.player ? `Tireur ${shoot.teamName} n°${shoot.player}` : '',
                result: shoot.result,
                eq: shoot.eq,
                score: editedScore
            }
        }, this.props.connexionReducer, this.id, this.actionId).then(response => {
            this.props.editActionLive(this.id, response.data);
        })
    }

    removeShoot(shoot) {
        removeAction(shoot.id, this.props.connexionReducer, this.id).then(() => {
            if(shoot.result === 'marque') {
                const score = substractScore(this.state.score, shoot.eq);
                this.setState({score});
            }
            this.props.deleteActionLive(this.id, shoot.id);
            this.props.removeActionLive(this.id, shoot.id);
            const shootToRemove = [...this.state.seq];
            _.remove(shootToRemove, s => s.id === shoot.id);
            this.setState({seq: shootToRemove});
        })
    }

    render() {
        const {seq, showBtn, isOnSubmit, match, shoot, score, onProgress} = this.state;
        const formValid = shoot.team !== '' && shoot.teamName !== '' && shoot.result !== '';

        return (
            <ActionFormLayout
                title='séance de tirs au but'
                submit={() => {
                    const backup = this.state.seq;
                    Modal.alert(
                        <span style={{...styles.common, fontWeight: 700, fontSize: 15}}>Fin de la séance des tirs au but ?</span>, 
                        <div style={styles.common}>En cliquant sur "OK" tu vas notifier tes spectateurs de la fin du match suite aux tirs au but !</div>,
                        [
                            {text: <span style={{...styles.common, fontWeight: 700}}>Annuler</span>},
                            {text: <span style={{...styles.common, fontWeight: 700}}>Ok</span>, onPress: () => {
                                if(!onProgress) {
                                    this.setState({isOnSubmit: true, seq: [], onProgress: true});
                                    if(formValid) {
                                        this.add();
                                    }
                                    this.endSeance().then(() => {
                                        this.setState({isOnSubmit: false, seq: backup, onProgress: false});
                                        this.props.history.push(`/live/${this.id}`)
                                    });
                                }
                            }}
                        ]
                    )

                }}
                enabled={!_.isEmpty(seq)}
                showBtn={showBtn}
                isOnSubmit={isOnSubmit}
                okBtn='Fin de la séance'
                position={seq.length >= 2 ? 'relative' : 'absolute'}
            >
            <div className='ls_debut_form'>
                <FreeKickTeamChoice 
                    homeTeamLogo={`${LOGO_TEAM_URL}/${match.homeTeamClCod}.jpg`}
                    homeTeamName={match.homeTeamEqName || match.homeTeam}
                    awayTeamLogo={`${LOGO_TEAM_URL}/${match.awayTeamClCod}.jpg`}
                    awayTeamName={match.awayTeamEqName || match.awayTeam}
                    score={score}
                    seq={seq}
                />
                { !this.editId && this.renderSeanceTir()}
                <List renderHeader={() => <Title text={`détails tir au but ${ !this.editId ? seq.length + 1 : ''}`} />}>
                    <PickerInput 
                        data={[
                            {label: match.homeTeamEqName || match.homeTeam, value: parseInt(match.homeTeamClCod)},
                            {label: match.awayTeamEqName || match.awayTeam, value: parseInt(match.awayTeamClCod)}
                        ]}
                        label='Equipe'
                        extra={'à renseigner'}
                        value={shoot.team}
                        onOk={team => this.setState({
                            shoot: {...shoot, 
                                team, 
                                teamName: team === parseInt(match.homeTeamClCod) ? (match.homeTeamEqName || match.homeTeam) : (match.awayTeamEqName || match.awayTeam),
                                eq: team === parseInt(match.homeTeamClCod) ? 'home' : 'away'
                            }
                        })}
                    />
                    <NumberInput 
                        label='Tireur (n° maillot)'
                        placeholder='à renseigner'
                        min={1}
                        max={99}
                        value={shoot.player}
                        defaultValue={shoot.player}
                        onChange={player => this.setState({shoot: {...shoot, player}})}
                        id='ls_maillot_tab'
                        onFocus={() => this.setState({showBtn: false})}
                        onBlur={() => this.setState({showBtn: true})}
                    />
                    <PickerInput 
                        data={[
                            {label: 'Marqué', value: 'marque'},
                            {label: 'Arrêté', value: 'arrete'},
                            {label: 'Manqué', value: 'manque'}
                        ]} 
                        label={'Finalité'} 
                        extra='à renseigner' 
                        value={shoot.result} 
                        onOk={result => this.setState({shoot: {...shoot, result}})} 
                    />
                </List>
                <List.Item
                    thumb={<Icon icon='md-plus' size={15} 
                    style={{color: '#004586', fontWeight: 700, opacity: formValid ? 1 : .2}} />}
                    onClick={() => this.addShoot()}
                >
                    <span style={{...styles.ajout_tir, opacity: formValid ? 1 : .2}}>{ this.editId ? 'MODIFIER LE TIR AU BUT' : 'AJOUTER UN TIR AU BUT'}</span>
                </List.Item>
            </div>
            </ActionFormLayout>
        )
    }
}

const styles = {
    ajout_tir: {
        color: '#004586', 
        fontWeight: 700,
        fontFamily: 'fff-equipe'
    },
    common: {
        fontFamily: 'fff-equipe',
        color: '#004586'
    }
}

const mapStateToProps = ({connexionReducer, liveDataReducer}) => ({connexionReducer, liveDataReducer});

const mapDispatchToProps = dispatch => bindActionCreators({fetchLive, addActionLive, editActionLive, removeActionLive, deleteActionLive, endLive}, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TirAuButFormPage));